import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAxiosInterceptors } from './utils/axiosInterceptor';
import { TenantProvider } from './Context/TenantContext';
import { installGlobalErrorHandlers } from './error-framework/globalErrorHandlers';

// Window-level error handling is installed FIRST, before anything else
// runs and before React mounts, so that a failure during startup (a bad
// chunk, a throwing module side-effect, a rejected promise in an early
// import) is still captured. React's <ErrorBoundary> cannot see any of
// those — it only covers the render phase of an already-mounted tree.
installGlobalErrorHandlers();

// Initialize axios interceptors for session token management
initAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TenantProvider>
      <App />
    </TenantProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



